import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getUser } from "@jti/rest-api";
import { Iframe, useTranslations } from "@jti/ui";
import styles from "./SurveyMonkey.module.scss";
export const SurveyMonkey = (props) => {
    const { __ } = useTranslations();
    const { scriptUrl } = props;
    const [surveyType, setSurveyType] = useState(undefined);
    const [uniqueCode, setUniqueCode] = useState(undefined);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setSurveyType(params.get("surveyType") || undefined);
        setUniqueCode(params.get("uniqueCode") || undefined);
    }, []);
    const user = getUser();
    const isSurveyDataValid = () => {
        if (!user.uuid || !uniqueCode) {
            const errorReason = `${__("loyalty.surveymonkey.iframe.error_message")}${!user.uuid ? "user UUID" : ""} ${!uniqueCode ? "promo code" : ""}`.trim();
            return errorReason;
        }
        return null;
    };
    const error = isSurveyDataValid();
    if (error) {
        return (_jsx("div", { className: styles.error, children: _jsx("p", { children: error }) }));
    }
    const surveyUrl = `${encodeURIComponent(scriptUrl)}?sureveyType=${encodeURIComponent(surveyType || "weekly-survey")}&casUUID=${encodeURIComponent(user.uuid)}&uniqueCode=${encodeURIComponent(uniqueCode)}`;
    return (_jsx("div", { className: styles.surveymonkey, children: _jsx(Iframe, { url: decodeURIComponent(surveyUrl) }) }));
};
//# sourceMappingURL=SurveyMonkey.js.map